import { StoryQuestion, useStoryQuestion } from '@/components/microstory/question';
import { select, t } from '@lingui/macro';

export function MentalBurdensQuestion3() {
  const { selectedAnswer, handleAnswer } = useStoryQuestion();

  const answers = [
    {
      id: 'younger',
      label: t({
        id: 'mental-burdens.question-3.answer-1',
        message: 'Being younger (15-19 versus 20-24 years old)',
      }),
    },
    {
      id: 'education',
      label: t({
        id: 'mental-burdens.question-3.answer-2',
        message: 'Having completed less formal education',
      }),
    },
    {
      id: 'finance',
      label: t({
        id: 'mental-burdens.question-3.answer-3',
        message: 'Feeling less financially comfortable',
      }),
    },
  ];

  return (
    <StoryQuestion
      question={t({
        message: `Which of these characteristics do you think is associated with frequently feeling anxious, nervous or worried among young people?`,
        id: 'mental-burden.question-3.question',
      })}
      answers={answers}
      selectedAnswer={selectedAnswer}
      response={
        selectedAnswer?.id &&
        t({
          id: 'mental-burdens.question-3.response',
          message: select(selectedAnswer?.id, {
            younger: 'Not quite!',
            education: 'Exactly!',
            finance: 'Exactly!',
          }),
        })
      }
      onAnswer={handleAnswer}
    />
  );
}
